module.exports = __webpack_public_path__ + "img/epay.797f40a7.svg";